

// export class Layout extends Component {
//   static displayName = Layout.name;
//   //await for children passed as props to render
//   //then render the children
//    async componentDidMount(){
//      await this.props.children;
//      this.setState({children: this.props.children});
//    }

//   render () {
//     return (
//       <div>
//       <NavMenu />
//       <Container
//           fluid
//           >
//             {this.props.children}
//       </Container>
//       </div>
//     );
//   }
// }

import React from 'react';
import { Container } from 'reactstrap';
import  NavMenu  from '../components/Nav.js';
import {Outlet} from 'react-router-dom';


function Layout(props) {
  const [children, setChildren] = React.useState(null);
  //await for children passed as props to render
  //then render the children
    React.useEffect(() => {
      setChildren(props.children);
    }, [props]);


  return (
         <div>
       <NavMenu />
       <Container
           fluid
           >
              {children}
       </Container>
       </div>
    )
}

export default Layout